import React, {useState} from "react";
import {applicativeService} from "../../../../jwt/_services/configuration/applicativeService";
import {GenericButton} from "../../../../components/buttons/customButtons";

const MetricsDetailsTable = ({modules, app, handleCalculateMetrics}) => <div className="table-responsive">
    <table className="table table-striped">
        <thead>
            <tr>
                <th>Modelo</th>
                <th className="text-center">Registros</th>
                <th className="text-center">Caracteres</th>
                <th className="text-center">Registros <br/>Traducidos</th>
                <th className="text-center">Registros <br/>Parcialmente Traducidos</th>
                <th className="text-center">Registros <br/>sin traducción</th>
                <th className="text-center">Traducir a <br/>idiomas activos</th>
            </tr>
        </thead>
        <tbody>
        {
            modules.map((module, index) => <tr key={index}>
                <td>{module.className.shortName}</td>
                <td className="text-center">{module?.totalRegisters}</td>
                <td className="text-center">{module?.totalCaracteres}</td>
                <td className="text-center">
                    {module?.totalTranslatedRegisters} / {module?.percentageTranslatedRegisters}%
                </td>
                <td className="text-center">
                    {module?.totalPartiallyTranslatedRegisters} / {module?.percentagePartiallyTranslatedRegisters}%
                </td>
                <td className="text-center">
                    {module?.totalUntranslatedRegisters} / {module?.percentageUntranslatedRegisters}%
                </td>
                <td className="text-center">
                    <TableButton module={module} app={app} handleCalculateMetrics={()=>handleCalculateMetrics(`lang${module.className.shortName}`)}/>
                </td>
            </tr>)
        }
        </tbody>
    </table>
</div>


export default MetricsDetailsTable;


const TableButton = ({module, app, handleCalculateMetrics}) => {
    const [loading, setLoading] = useState(false)

    const handleTranslate = ({className:{shortName}}) => {
        if(loading){
            console.warn('Ya se está traduciendo')
            return
        }

        const requestData = {
            item: {
                applicative: app?.id,
                modulo: `lang${shortName}`
            }
        }

        setLoading(true)

        applicativeService.translateModule(requestData)
            .then(response => {
                if(response?.status)
                    handleCalculateMetrics()
            })
            .finally(() => setLoading(false))

    }


    return <GenericButton
        style={"secondary"}
        label={'Traducir'}
        icon={'fa-language'}
        toolTip={`Traducir ${module?.className?.shortName}`}
        onClick={() => handleTranslate(module)}
        loading={loading}
    />

}
